import React, { useEffect, useState } from 'react';
import { Route, Switch, Link, withRouter } from 'react-router-dom';
import { 
    Grid,
    Menu,
    Segment,
    Sidebar
} from 'semantic-ui-react';

import { AddEdit } from './AddEdit';
import { List } from './List';
import SideBarMenu from '../_components/SideBarMenu';
import Report from './Report';

function Request({ match, location }) {
    const { path } = match;
    const [pathname, setPathname] = useState(<SideBarMenu mode="list" path={path} page="Orders"/>);

    useEffect(() => {
        const loc = location.pathname;
        if (loc === "/requests") {
            setPathname(<SideBarMenu mode={"list"} path={path} page="Orders"/>);
        } else if (loc.match(`${path}/edit/`)) {
            setPathname(<SideBarMenu mode={"edit"} path={path} page="Orders"/>);
        } else if (loc.match(`${path}/view/`)) {
            setPathname(<SideBarMenu mode={"view"} path={path} page="Orders"/>);
        } else if (loc === `${path}/add`) {
            setPathname(<SideBarMenu mode={"add"} path={path} page="Orders"/>);
        }
    }, [location.pathname]);

    return (
        <Grid columns={1} className="pr-4">
            <Grid.Column>
                <Sidebar.Pushable as={Segment}>
                    <Sidebar
                    as={Menu}
                    width="248px"
                    visible={true}
                    >
                        {pathname}
                    </Sidebar>
                    <Sidebar.Pusher className="pushed-segment pr-3">
                        <Segment basic>
                            <Switch>
                                <Route exact path={path} component={List} />
                                <Route path={`${path}/add`} component={AddEdit}/>
                                <Route path={`${path}/view/:id`} component={AddEdit} />
                                <Route path={`${path}/edit/:id`} component={AddEdit} />
                                <Route path={`${path}/report/:id`} component={Report}/>
                            </Switch>
                        </Segment>
                    </Sidebar.Pusher>
                </Sidebar.Pushable>
            </Grid.Column>
        </Grid>
    );
}

const Requests = withRouter(Request);
export { Requests };
